module.exports = __webpack_public_path__ + "img/war-combine.9287c733.png";